import { platformType, detectType, clientName } from "../common/constants";
export var clients = [{
  name: clientName.mpWebAlipayPlus,
  regs: [/alipayIDE/i],
  detectType: detectType.ua,
  type: platformType.mpWeb
}, {
  name: clientName.mpWebAlipayPlus,
  regs: [/miniprogram/i, /griver/i],
  detectType: detectType.ua,
  type: platformType.mpWeb
}, {
  name: clientName.mpWebAlipay,
  regs: [/miniprogram/i, /alipay/i, /^((?!griver).)*$/i],
  detectType: detectType.ua,
  type: platformType.mpWeb
}, {
  name: clientName.webAlipayPlus,
  regs: [/^((?!miniprogram).)*$/i, /griver/i],
  detectType: detectType.ua,
  type: platformType.web
}, {
  name: clientName.webAlipay,
  regs: [/^((?!miniprogram).)*$/i, /AlipayClient/i, /^((?!griver).)*$/i],
  detectType: detectType.ua,
  type: platformType.web
}, {
  name: clientName.mpTaobao,
  regs: [/taobao|tb/i],
  detectType: detectType.app,
  type: platformType.mp
}, {
  name: clientName.mpLazada,
  regs: [/lazada|la/i],
  detectType: detectType.app,
  type: platformType.mp
}, {
  name: clientName.mpAlipay,
  regs: [/alipay/i],
  detectType: detectType.app,
  type: platformType.mp
}, {
  name: clientName.mpAlipayPlus,
  regs: [],
  detectType: detectType.app,
  type: platformType.mp
}];
export var clientDefault = {
  mp: {
    name: clientName.mpAlipayPlus,
    type: platformType.mp
  },
  mpWeb: {
    name: clientName.mpWebAlipayPlus,
    type: platformType.mpWeb
  },
  web: {
    name: clientName.webAlipayPlus,
    type: platformType.web
  }
};